import React from "react";
import { LOGO_URL } from "@/lib/tps";

export default function Logo({ size = 40, withText = false, variant = "default" }) {
  const bg = variant === "light" ? "bg-white" : "bg-[#B86F77]";
  return (
    <div className="flex items-center gap-2" data-testid="brand-logo">
      <div
        className={`${bg} rounded-md overflow-hidden flex items-center justify-center shrink-0`}
        style={{ width: size, height: size }}
      >
        <img
          src={LOGO_URL}
          alt="The Palate Stories"
          className="object-cover"
          style={{ width: size * 1.2, height: size * 1.2, objectPosition: "center" }}
        />
      </div>
      {withText && (
        <div className="leading-tight">
          <div className="font-heading font-semibold text-[#141E30] text-base">The Palate Stories</div>
          <div className="text-[10px] uppercase tracking-widest text-[#4B5563]">Patisserie & Bake Studio</div>
        </div>
      )}
    </div>
  );
}
